import { isDisplayableEvaluatedPrice } from "../../../../tools/ItineraryPricingEvaluationDisplay.tools";
import { type ProviderOffer } from "../../../../types/dtos/api/sales/provider-offer.dto";
import { type ProviderPricingEvaluation } from "./OfferPricing.types";

const PROVIDER_PRIORITY: ProviderOffer["provider"][] = [
    "swiss_cff",
    "blablacar",
    "blabladaily",
    "rental_motis",
    "completion_strategy",
    "unknown",
];

/**
 * Selects one evaluation using deterministic provider priority.
 *
 * @remarks
 * The policy prefers providers with a price first, then falls back to provider-only entries.
 *
 * @param evaluations Provider evaluations produced for one segment.
 * @returns Selected evaluation, or `null` when nothing is available.
 */
export const selectPreferredEvaluation = ( evaluations: ProviderPricingEvaluation[] ): ProviderPricingEvaluation | null => {
    if ( evaluations.length === 0 ) {
        return null;
    }

    for ( const providerKey of PROVIDER_PRIORITY ) {
        const priced = evaluations.find( ( evaluation ) => evaluation.providerKey === providerKey && isDisplayableEvaluatedPrice( evaluation.price ) );
        if ( priced !== undefined ) {
            return priced;
        }
    }

    for ( const providerKey of PROVIDER_PRIORITY ) {
        const providerOnly = evaluations.find( ( evaluation ) => evaluation.providerKey === providerKey );
        if ( providerOnly !== undefined ) {
            return providerOnly;
        }
    }

    return evaluations[0];
};
